import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "workflows-list" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("New Workflow")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table = _resolveComponent("el-table")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, { onClick: _ctx.routeToCreateWorkflow }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, {
      type: "danger",
      onClick: _ctx.deleteWorkflows,
      disabled: _ctx.selected.length < 1
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.workflows,
      stripe: "",
      "default-expand-all": true,
      onSelectionChange: _ctx.onSelectChanged
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          prop: _ctx.TITLE_KEY,
          label: "Title"
        }, null, 8, ["prop"]),
        (_ctx.isSuperAdmin || _ctx.isVAR)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Organization"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(_ctx.orgMap[row.org]), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: _ctx.DATE_CREATED_KEY,
          label: "Created"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.convertDateString(scope.row[_ctx.DATE_CREATED_KEY], _ctx.userPrefs?.timezone)), 1)
          ]),
          _: 1
        }, 8, ["prop"]),
        _createVNode(_component_el_table_column, {
          prop: _ctx.DATE_MODIFIED_KEY,
          label: "Modified"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.convertDateString(scope.row[_ctx.DATE_MODIFIED_KEY], _ctx.userPrefs?.timezone)), 1)
          ]),
          _: 1
        }, 8, ["prop"]),
        _createVNode(_component_el_table_column, { label: "Options" }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_link, {
              class: "el-button el-button--mini is-circle",
              size: "mini",
              href: `/#/workflows/${row._id}`,
              icon: "el-icon-edit-outline",
              underline: false,
              circle: "",
              plain: ""
            }, null, 8, ["href"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "onSelectionChange"]), [
      [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
    ])
  ]))
}